module.exports = __webpack_public_path__ + "static/21invgde-602bec3ef91d4d233ae74c6c49b0f8bb.gif";